import { createDocumentRevisionsStore } from '@/entities/Document/@x/Record';
import type { EligibleMatrixResponse } from '../api';

/**
 * Server-side paginated eligible matrices for the container the modal was opened for.
 *
 * The listing answers the same envelope as the document searches, so the generic store
 * carries page, batch append, loading flags and metadata; only the mapping to `RecordItem`
 * is the Record entity's own, and it happens where the rows are rendered.
 */
export const useEligibleMatricesStore =
  createDocumentRevisionsStore<EligibleMatrixResponse>('eligibleMatrices');
